/* eslint-disable no-console */
import React, { useEffect, useRef, useState } from "react";

export interface IdleTrackerProps {
  seconds: number;
  onIdle?: () => void;
  onActive?: () => void;
  onHide?: () => void;
  onShow?: () => void;
}

const IdleTracker: React.FC<IdleTrackerProps> = props => {
  const { seconds, onIdle, onActive, onHide, onShow } = props;
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isIdle = useRef(false);
  const countdownIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const [time, setTime] = useState(seconds);

  useEffect(() => {
    if (time === 0) {
      return;
    }

    const timer = setInterval(() => setTime(time - 1), 1000);
    return () => clearInterval(timer);
  }, [time]);

  const resetTimer = () => {
    setTime(seconds);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      if (!isIdle.current) {
        isIdle.current = true;
        console.log("User is idle");
        if (onIdle) {
          onIdle();
        }
      }
    }, seconds * 1000);

    if (isIdle.current) {
      isIdle.current = false;
      console.log("User is active");
      if (onActive) {
        onActive();
      }
    }
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("Window is hidden");
        if (onHide) {
          onHide();
        }
      } else {
        console.log("Window is visible");
        if (onShow) {
          onShow();
        }
      }
    };

    const events = ["mousemove", "keydown", "mousedown", "touchstart"];
    events.forEach(event => window.addEventListener(event, resetTimer));
    document.addEventListener("visibilitychange", handleVisibilityChange);

    resetTimer();

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
      }
    };
  }, []);

  return (
    <div
      style={{
        color: "#747C8C",
        textAlign: "center",
        width: "100%"
      }}
    >
      This form will close after <strong>{time}s</strong> of inactivity.
    </div>
  );
};

export default IdleTracker;
